import React from 'react';
import Classes from './styles/style.module.css';
import Logo from '../Home/Components/Logo/Logo';

function DataPolicy() {
    return (
        <>
            <div className={Classes.navContainer} style={{ boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.06)' }} >
                <div>
                    <a className={Classes.logoLink} href="/">
                        <Logo alwaysShowText={true} />
                    </a>
                </div>
                <nav className={Classes.navMenu}>

                </nav>
                <div>
                    <a href="/">
                        <h5 className={Classes.goBackTxt} >Go back to Privacybot.com</h5>
                    </a>
                </div>
            </div>
            <div className={Classes.hero}>
                <h1>Data Security Policy</h1>
                <div className={Classes.form_con}>
                    <h5>Effective Date: May 11th, 2025</h5>
                    <br />
                    <h5>
                        <a href='https://privacybot.com' target='_blank' >privacybot.com</a> ("PrivacyBot," "we," "us," or "our") is committed to protecting the security of your data. This Data Security Policy outlines the measures we take to safeguard the information entrusted to us when you use our website, platform, products, and services (collectively, the "Services").
                        <br /><br />
                        By using the Services, you acknowledge and agree to the practices described in this Data Security Policy.
                    </h5>
                    <br />

                    <h5 className={Classes.major_title}>1. Infrastructure Security</h5>
                    <h5>Our platform is hosted on secure, industry-leading cloud infrastructure providers.</h5>
                    <br />
                    <h5>We use best practices for infrastructure management, including:</h5>
                    <ul>
                        <li>
                            <h5>Encryption of data at rest and in transit using SSL/TLS</h5>
                        </li>
                        <li>
                            <h5>Regular security patching and updates</h5>
                        </li>
                        <li>
                            <h5>Firewalls and intrusion detection systems to monitor and protect network access</h5>
                        </li>
                    </ul>
                    <br />

                    <h5 className={Classes.major_title}>2. Access Control</h5>
                    <h5>Access to systems and customer data is strictly limited to authorized personnel who require access to perform their job duties.</h5>
                    <br />
                    <h5>We enforce:</h5>
                    <ul>
                        <li>
                            <h5>Role-based access controls (RBAC)</h5>
                        </li>
                        <li>
                            <h5>Strong password policies and multi-factor authentication (MFA)</h5>
                        </li>
                        <li>
                            <h5>Regular audits and reviews of access permissions</h5>
                        </li>
                    </ul>
                    <br />

                    <h5 className={Classes.major_title}>3. Data Protection</h5>
                    <h5>We protect your data through a combination of technical, administrative, and physical controls, including:</h5>
                    <ul>
                        <li>
                            <h5>Encryption of sensitive data both in transit and at rest</h5>
                        </li>
                        <li>
                            <h5>Secure data backups performed regularly</h5>
                        </li>
                        <li>
                            <h5>Logical separation of customer data in shared environments</h5>
                        </li>
                    </ul>
                    <br />

                    <h5 className={Classes.major_title}>4. Monitoring and Incident Response</h5>
                    <h5>We actively monitor our systems for unauthorized access, vulnerabilities, and unusual activity.</h5>
                    <br />
                    <h5>In the event of a data breach or security incident, we have an incident response plan that includes:</h5>
                    <ul>
                        <li>
                            <h5>Immediate investigation and containment</h5>
                        </li>
                        <li>
                            <h5>Notification to affected customers as required by applicable law</h5>
                        </li>
                        <li>
                            <h5>Corrective actions to prevent future incidents</h5>
                        </li>
                    </ul>
                    <br />

                    <h5 className={Classes.major_title}>5. Employee Training</h5>
                    <h5>All employees are trained on security best practices, data protection obligations, and safe handling of sensitive information.</h5>
                    <br />
                    <h5>Security training is conducted during onboarding and updated regularly.</h5>
                    <br />

                    <h5 className={Classes.major_title}>6. Third-Party Security</h5>
                    <h5>When we engage third-party service providers, we assess their security practices to ensure they meet standards consistent with this Data Security Policy.</h5>
                    <br />
                    <h5>All third-party providers with access to data are contractually obligated to protect it.</h5>
                    <br />

                    <h5 className={Classes.major_title}>7. Customer Responsibilities</h5>
                    <h5>While privacybot.com implements security measures to protect your data, customers are responsible for:</h5>
                    <ul>
                        <li>
                            <h5>Protecting account credentials and passwords</h5>
                        </li>
                        <li>
                            <h5>Maintaining the security of client data uploaded into the platform</h5>
                        </li>
                        <li>
                            <h5>Ensuring compliance with their own data protection obligations</h5>
                        </li>
                    </ul>
                    <br />

                    <h5 className={Classes.major_title}>8. Changes to This Policy</h5>
                    <h5>We may update this Data Security Policy from time to time to reflect changes in technology, law, or our practices.</h5>
                    <br />
                    <h5>Material updates will be communicated through the Services or other appropriate channels.</h5>
                    <br />
                    <h5>Your continued use of the Services after any changes become effective constitutes your acceptance of the revised Data Security Policy.</h5>
                    <br />

                    <h5 className={Classes.major_title}>9. Contact Us</h5>
                    <h5>
                        If you have any questions about this Data Security Policy or our data protection practices, please contact us at:
                        <br /><br />
                        privacybot.com
                        <br />
                        Support@privacybot.com
                    </h5>
                    <br />

                    <h5 className={Classes.major_title}>10. Governing Law</h5>
                    <h5>This Data Security Policy shall be governed by and construed in accordance with the laws of the State of New York, without regard to its conflict of law principles.</h5>
                    <br />
                </div>
            </div>
        </>
    );
}

export default DataPolicy;
